module.exports = __webpack_public_path__ + "img/beginShow.a7b791d4.svg";